import React from 'react';
import { TouchTarget } from 'apps/sigma2-ui/src/components/ui/TouchTarget';
import { IconCardCheckboxCheckedSvg } from 'apps/sigma2-ui/src/components/svg/IconCardCheckboxChecked';
import { IconCardCheckboxUncheckedSvg } from 'apps/sigma2-ui/src/components/svg/IconCardCheckboxUnchecked';

export interface CardCheckboxProps {
  checked: boolean;
  onCheck: () => void;
}

export const CardCheckbox: React.FC<CardCheckboxProps> = ({
  checked,
  onCheck,
}) => {
  return (
    <TouchTarget
      content={() => {
        return checked ? (
          <IconCardCheckboxCheckedSvg svg={{ className: 'w-6 h-6' }} />
        ) : (
          <IconCardCheckboxUncheckedSvg svg={{ className: 'w-6 h-6' }} />
        );
      }}
      behavior={{ type: 'onClick', onClick: onCheck }}
      className={'p-2'}
    />
  );
};
